// Per-route page metadata (title, description, canonical, Open Graph).
//
// react-snap serializes the live DOM after render, so setting document.title
// and the <meta>/<link> tags on navigation gives each pre-rendered route its
// own unique metadata in the static HTML. This is what keeps Google from
// treating every URL as a duplicate of the SPA shell.

import { ORIGIN, ROUTE_META } from "../content/routes";

const SITE_NAME = "Striply";
const DEFAULT_TITLE = "Striply — Comic Page Layout Editor";

export { ROUTE_META };

function setMetaByName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setMetaByProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Apply metadata for the given pathname. Returns the resolved title so callers
// (e.g. analytics) can report the page title that was actually set.
export function applyPageMeta(pathname) {
  const key = pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;
  const meta = ROUTE_META[key] || { title: DEFAULT_TITLE, description: "" };
  const title = meta.title || DEFAULT_TITLE;
  const url = ORIGIN + (key === "/" ? "/" : key);

  document.title = title;
  setMetaByName("description", meta.description);
  setCanonical(url);

  setMetaByProperty("og:title", title);
  setMetaByProperty("og:description", meta.description);
  setMetaByProperty("og:url", url);
  setMetaByProperty("og:type", "website");
  setMetaByProperty("og:site_name", SITE_NAME);

  return title;
}
